<template>
  <div class="contentDetails">
    <NavBar :navBlock='navBlock' :navtitle='navtitle' :pageBack='true'></NavBar>
      <div class="detailsContent">
        <Banner :type='type'></Banner>
      </div>
  </div>
</template>

<script>
import NavBar from '@/components/navBar'
import Banner from '@/components/marketBanner';
export default {
  data () {
    return {
      navBlock:'Banner管理  /  商城banner',
      navtitle:'新增banner',
      type: 'add'
    }
  },
  created(){
  },
  methods:{
  },
  components: {
    Banner,
    NavBar
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/banner/marketBanner/addMarketBanner.vue